"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccordionGroupStyles = void 0;
const Utils_1 = require("../../../utils/Utils");
const StyleUtils_1 = require("../../../utils/StyleUtils");
exports.getAccordionGroupStyles = (0, Utils_1.createStyleSheet)({
    container: Object.assign(Object.assign({}, (0, StyleUtils_1.flexMixin)('column')), { width: '100%' }),
}, { name: 'Blueprint-AccordionGroup' });
